import React from 'react';
import PropTypes from 'prop-types';
import {getStyle} from "../../../services/Style";

export default class ShareButtons extends React.PureComponent {

    className = "share-job-post";

    static propTypes = {
        language: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        customerName: PropTypes.string.isRequired
    };

    renderFacebook = () => {
        return (
            <a
	            className="fb-xfbml-parse-ignore cursor-pointer"
	            target="_blank"
	            href={"https://www.facebook.com/sharer/sharer.php?u="+ encodeURI(this.props.link) +"&amp;src=sdkpreparse"}
	            rel="noreferrer noopener"
            >
                <i className="fab fa-facebook-f"/>
            </a>
        );
    };

    renderTwitter = () => {
        return (
            <a className="cursor-pointer" href={"https://twitter.com/intent/tweet?text="+encodeURI(this.props.link)}><i className="fab fa-twitter"/></a>
        );
    };


    renderLinkedIn = () => {
        return (
            <a className="cursor-pointer" href={"https://www.linkedin.com/shareArticle?mini=true&url="+encodeURI(this.props.link)}>
                <i className="fab fa-linkedin-in"/>
            </a>
        )
    };

    render() {
        return (
            <div className={this.className} style = {getStyle(this.props.positionId, this.className, this.props.customerName)}>
                <span className="share"> <i className="fas fa-share-alt"/>{window.Translator.getSlug('Share', this.props.language)}:</span>
                { this.renderFacebook() }
                { this.renderTwitter() }
                { this.renderLinkedIn() }
            </div>
        );
    }
}
